import React from "react";

function Footer() {
    return (
      <footer className="modern-footer">
        <div className="footer-container">
            <div className="footer-section">
                <h3 className="footer-title">Partnerships & Collaborations</h3>
                <div className="partners-grid">
                    <a href="https://www.uq.edu.au" target="_blank" rel="noreferrer" className="partner-link">
                        <img className="partner-logo" src={require("./icon/UQ.png")} alt="University of Queensland" />
                    </a>
                    <a href="https://conservationpartners.org.au" target="_blank" rel="noreferrer" className="partner-link">
                        <img className="partner-logo" src={require("./icon/conservation.jpg")} alt="Conservation Partners"/>
                    </a>
                    <a href="https://www.csiro.au" target="_blank" rel="noreferrer" className="partner-link">
                        <img className="partner-logo" src={require("./icon/CSIRO.png")} alt="CSIRO"/>
                    </a>
                    <a href="https://www.jcu.edu.au" target="_blank" rel="noreferrer" className="partner-link">
                        <img className="partner-logo" src={require("./icon/JCU.png")} alt="James Cook University"/>
                    </a>
                    <a href="https://www.nsw.gov.au" target="_blank" rel="noreferrer" className="partner-link">
                        <img className="partner-logo" src={require("./icon/NSW.jpg")} alt="NSW Government"/>
                    </a>
                </div>
            </div>
            
            <div className="footer-section">
                <h4 className="footer-subtitle">Contact Info</h4>
                <a href="mailto:uqwildsearching@gmail.com" className="footer-link">
                    uqwildsearching@gmail.com
                </a>
                <a 
                    href="https://ventures.uq.edu.au/article/2023/07/bird-identification-ai-technology-rises-top-pecking-order" 
                    target="_blank" 
                    rel="noreferrer" 
                    className="footer-link"
                >
                    UQ Ventures
                </a>
            </div>
        </div>
      </footer>
    )
}

export default Footer
